import * as Sentry from '@sentry/react'

const RATE_WINDOW_MS = 10_000

interface WebsocketEventSummary {
  action: string
  statementId?: number
  status?: string
  segments?: number
  transactions?: number
}

interface WebsocketEvent {
  action?: string
  statement?: { id?: number; status?: string; segments?: unknown[] }
  project?: { status?: string }
  statements?: unknown[]
  transactions?: unknown[]
}

const recentTimestamps: number[] = []

export const summarizeWebsocketEvent = (
  event: WebsocketEvent,
): WebsocketEventSummary => ({
  action: event.action ?? 'unknown',
  statementId: event.statement?.id,
  status: event.statement?.status ?? event.project?.status,
  segments: event.statement?.segments?.length ?? event.statements?.length,
  transactions: event.transactions?.length,
})

const countRecent = (now: number) => {
  recentTimestamps.push(now)
  while (recentTimestamps[0] < now - RATE_WINDOW_MS) recentTimestamps.shift()
  return recentTimestamps.length
}

export const recordWebsocketEvent = (
  channel: string,
  event: WebsocketEvent,
) => {
  const summary = summarizeWebsocketEvent(event)

  Sentry.addBreadcrumb({
    category: 'websocket',
    message: `${channel} ${summary.action}`,
    data: { ...summary },
    level: 'info',
  })
  Sentry.setContext('websocket', {
    channel,
    lastEvent: summary,
    eventsInLast10s: countRecent(Date.now()),
  })
}
